module.exports = __webpack_public_path__ + "img/3-small.33d29f56.png";